<template>
  <div class="p-postEditor__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <HeadingItemPreview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <h3>見出し</h3>
      <v-select
        :value="editingItemable.headingType"
        :items="items"
        item-text="headingType"
        item-value="value"
        label="見出しの種類"
        :placeholder="items[0].headingType"
        :rules="[presenceValidation]"
        class="body-2"
        style="width: 300px"
        dense
        single-line
        @change="updateEditingItemable($event, 'headingType')"
      />
      <v-text-field
        :value="editingItemable.content"
        counter
        :rules="[presenceValidation]"
        label="見出し本文"
        autofocus
        required
        @input="updateEditingItemable($event, 'content')"
      />
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import HeadingItemPreview from './previews/HeadingItemPreview'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'HeadingItem',
  components: { HeadingItemPreview },
  mixins: [itemUtilsMixin, formValidationUtils],
  data: () => {
    return {
      items: [
        { headingType: '見出し2', value: 2 },
        { headingType: '見出し3', value: 3 },
        { headingType: '見出し4', value: 4 }
      ]
    }
  },
  computed: {
    content: function () {
      return this.item.itemableAttributes.content
    },
    headingTypeString: function () {
      return this.item.itemableAttributes.headingType
    }
  }
}
</script>

<style scoped></style>
